// extracted by mini-css-extract-plugin
module.exports = {"field":"aXR2t","inline":"Leevi"};